export { UnitV3TrainingCardContainer as UnitV3TrainingCard } from './container'
